import styled from "styled-components";
import { IRowStyled } from "./interface";

export const Component = styled.div<IRowStyled>`
    display: ${props => props.display ?? "flex"};

    @media (max-width: 500px){
        display: block;
    }
`;